import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
 import { push } from 'react-router-redux';
import * as changePasswordActions  from './../../actions/changePasswordActions';
import * as commonActions from './../../actions/commonActions';
import * as authActions from '../../redux/modules/auth';
import styles from './ChangePassword.less';
import '../../../node_modules/react-grid-layout/css/styles.css';
import '../../../node_modules/react-resizable/css/styles.css';

@connect(
 state => ({
      user: state.dashboardRoot.changePasswordReducer.user,
      //  showPopup: state.dashboardRoot.changePasswordReducer.showPopup,
      loginStatus:state.auth.loginStatus,
      message:state.dashboardRoot.changePasswordReducer.message,
      changePassStatus:state.dashboardRoot.changePasswordReducer.changePassStatus,
      showRP: state.dashboardRoot.changePasswordReducer.showRP}),
    {...changePasswordActions, ...commonActions, ...authActions, pushState: push})
export default class ChangePasswordComponent extends Component{

  static propTypes = {
    CloseIcon: PropTypes.object,
    keyValue: PropTypes.string.isRequired,
    deleteWidget: PropTypes.func,
    pushState: PropTypes.func,
    user: PropTypes.object,
    changePassword: PropTypes.func,
    message: PropTypes.string,
    showPreview: PropTypes.object,
    //modalHide: PropTypes.func,
    clickedEdit: PropTypes.bool,
    //showPopup: PropTypes.bool
    handleResetPwdStatus: PropTypes.func
    };
  state = {
    clickedRemove: false,
    errorFlag:false,
    oldPwd:'',
    newPwd:'',
    confirmNewPwd:'',
    loginStatus:this.props.loginStatus,
    changePassStatus:false,
  }
  closeWidget = (keyValue) => {
    try{
      this.setState({ clickedRemove: true });
      this.props.deleteWidget(keyValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeWidget', component:"ChangePasswordComponent"});
    }
  }
  passwordChangeHandler = (event) =>{
    try{
      this.setState({[event.target.name]: event.target.value.trim()});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'passwordChangeHandler', component:"ChangePasswordComponent"});
    }
  }
  componentWillReceiveProps(nextProps,nextState){
    if(nextProps.changePassStatus !==  this.props.changePassStatus){
      this.setState({changePassStatus:nextProps.changePassStatus})
    }
  }
   handleSubmit = (event) => {
    try{
      event.preventDefault();
      //this.setState({loginStatus:"loginnn"});
      this.setState({changePassStatus:true});
      var oldpassInput = this.state.oldPwd.trim();
      var newpassInput = this.state.newPwd.trim();
      var confpassInput = this.state.confirmNewPwd.trim();
      const username = JSON.parse(localStorage.getItem('user'));
      var location = localStorage.getItem('location');
      let flag = 0;
      if(oldpassInput === '' ){
        this.setState({errorFlag :true});
        this.setState({errorMsg :'Old Password should not be blank'});
        this.setState({changePassStatus:false})
      } else if(newpassInput === '' || confpassInput  === ''){
        this.setState({errorFlag :true});
        this.setState({errorMsg :'New Password And Confirm Password should not be blank'});
        this.setState({changePassStatus:false})
      } else if(newpassInput !== confpassInput){
        this.setState({errorFlag :true});
        this.setState({errorMsg :'New Password And Confirm Password do not match'});
        this.setState({changePassStatus:false})
      } else if(oldpassInput === newpassInput ){
        this.setState({errorFlag :true});
        this.setState({errorMsg :'New Password should not be same as Old Password'});
        this.setState({changePassStatus:false})
      } else if(!newpassInput.match(/^(?=.*[A-Za-z&@!#$])(?=.*\d)[A-Za-z&@!#$\d]{8,16}$/)){
        this.setState({errorFlag :true});
        this.setState({errorMsg :"Password should be 8-16 characters long. It must be alphanumeric and can contain special characters such as &@!#$."});
        this.setState({changePassStatus:false})
      } else{
         this.setState({errorFlag :false});
         this.setState({errorMsg :''});
        const resetPass = {oldpass: oldpassInput,  newpass: newpassInput,  location: location};
        this.props.changePassword(resetPass);
        this.props.handleResetPwdStatus()
      }
      this.setState({
        oldPwd: '',
        newPwd: '',
        confirmNewPwd: ''
      });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleSubmit', component:"ChangePasswordComponent"});
    }
  }

  render() {
    const { showPreview, CloseIcon } = this.props;
    const user = JSON.parse(localStorage.getItem('user'));
    return (

            <div style={{padding: '20px'}}>
               <div className={`${styles.paraDiv} col-md-12`}>
            {this.state.errorFlag === true ?
              <p className={styles.alertError}>{this.state.errorMsg}</p> :
                this.props.message !== "" ? <p className={styles.alertError}>{this.props.message}</p> : null }
            </div>
              <form className="login-form" id="loginForm">
                <input type="password" value={this.state.oldPwd} name="oldPwd" id="oldPwd" onChange={this.passwordChangeHandler} placeholder="Old Password" className={`${styles.oldPassInput} form-control cpassWord`} required="required"/>
                <input type="password" value={this.state.newPwd} name="newPwd" id="newPwd" onChange={this.passwordChangeHandler} placeholder="New Password" className={`${styles.newPassInput} form-control cpassWord`} required="required"/>
                <input type="password" value={this.state.confirmNewPwd} name="confirmNewPwd" onChange={this.passwordChangeHandler} id="confirmNewPwd" placeholder="Confirm Password" className={`${styles.confPassInput} form-control cpassWord`} required="required"/>
                <div className={styles.btnDiv}>
                  {/*<button onClick={this.handleSubmit} id="submitLoginForm">SUBMIT</button>*/}
                  {this.state.changePassStatus === false ? <button onClick={this.handleSubmit} id="submitLoginForm">SUBMIT</button> : <button type="button"><img src="/images/loader.gif"/></button>}
                </div>
              </form>

            </div>

    );
  }
}
